// import React, { useEffect, useMemo, useState } from "react";
// import RoleToggle from "../../components/RoleToggle";
// import InventoryCheckTab from "./_components/InventoryCheckTab";
// import InventoryTab from "./_components/InventoryTab";
// import ItemInventory from "./_components/ItemInventory";
// import { useSelector } from "react-redux";
// import { selectClientPermissions } from "../../features/auth/authSlice";
// import ProductItemsMovement from "./_components/ProductMovement";
// import LeadWMSDashboard from "./_components/WarehouseDashboard";

// interface TabConfig {
//   key: string;
//   label: string;
//   component: React.ReactNode;
//   modules: string[];
//   operation: "read";
// }

// const hasPermission = (
//   permissions: ReturnType<typeof selectClientPermissions>,
//   modules: string[],
//   operation: "read"
// ) => {
//   if (!permissions) return false;
//   return modules.some((mod) =>
//     permissions.some((p) => p.module === mod && p.operations.includes(operation))
//   );
// };

// const InventoryTabMain: React.FC = () => {
//   const permissions = useSelector(selectClientPermissions);
//   const outerTabs: TabConfig[] = useMemo(
//     () => [
//       {
//         key: "ShipmentInventory",
//         label: "Shipment Inventory",
//         component: null,
//         modules: ["shipment_inventory"],
//         operation: "read",
//       },
//       {
//         key: "inventoryHeatMap",
//         label: "Inventory Dashboard",
//         component: <LeadWMSDashboard />,
//         modules: ["product_inventory"],
//         operation: "read",
//       },
//     ],
//     []
//   );

//   const innerTabsForShipment: TabConfig[] = useMemo(
//     () => [
//       {
//         key: "Inventory",
//         label: "Inventory",
//         component: <InventoryTab />,
//         modules: ["shipment_inventory"],
//         operation: "read",
//       },
//       {
//         key: "InventoryCheck",
//         label: "Inventory Check",
//         component: <InventoryCheckTab />,
//         modules: ["shipment_inventory"],
//         operation: "read",
//       },
//     ],
//     []
//   );

//   const visibleOuter = useMemo(
//     () => outerTabs.filter((t) => hasPermission(permissions, t.modules, "read")),
//     [permissions, outerTabs]
//   );

//   const visibleInner = useMemo(
//     () =>
//       innerTabsForShipment.filter((t) =>
//         hasPermission(permissions, t.modules, "read")
//       ),
//     [permissions, innerTabsForShipment]
//   );

//   const shouldShowShipmentOuter =
//     visibleOuter.some((t) => t.key === "ShipmentInventory") && visibleInner.length > 0;

//   const finalVisibleOuter = useMemo(() => {
//     if (!shouldShowShipmentOuter) {
//       return visibleOuter.filter((t) => t.key !== "ShipmentInventory");
//     }
//     return visibleOuter;
//   }, [visibleOuter, shouldShowShipmentOuter]);

//   const [activeOuter, setActiveOuter] = useState<string>(() => {
//     const saved = localStorage.getItem("InventoryWiseActiveRole");
//     return saved && finalVisibleOuter.some((t) => t.key === saved)
//       ? saved
//       : finalVisibleOuter[0]?.key ?? "";
//   });

//   useEffect(() => {
//     if (activeOuter) localStorage.setItem("InventoryWiseActiveRole", activeOuter);
//   }, [activeOuter]);

//   const [activeInner, setActiveInner] = useState<string>(() => {
//     const saved = localStorage.getItem("InventoryCheckActiveRole");
//     return saved && visibleInner.some((t) => t.key === saved)
//       ? saved
//       : visibleInner[0]?.key ?? "";
//   });

//   useEffect(() => {
//     if (activeInner) localStorage.setItem("InventoryCheckActiveRole", activeInner);
//   }, [activeInner]);

//   useEffect(() => {
//     if (finalVisibleOuter.length && !finalVisibleOuter.some((t) => t.key === activeOuter)) {
//       setActiveOuter(finalVisibleOuter[0].key);
//     }
//   }, [finalVisibleOuter, activeOuter]);

//   useEffect(() => {
//     if (
//       activeOuter === "ShipmentInventory" &&
//       visibleInner.length &&
//       !visibleInner.some((t) => t.key === activeInner)
//     ) {
//       setActiveInner(visibleInner[0].key);
//     }
//   }, [visibleInner, activeInner, activeOuter]);

//   const activeOuterTab = finalVisibleOuter.find((t) => t.key === activeOuter);
//   const activeInnerTab = visibleInner.find((t) => t.key === activeInner);

//   if (finalVisibleOuter.length === 1 && finalVisibleOuter[0].key === "ItemsInventory") {
//     return (
//       <div className="space-y-4">
//         <ItemInventory />
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-4">
//       {finalVisibleOuter.length > 1 && (
//         <div className="flex justify-between items-center">
//           <RoleToggle
//             options={finalVisibleOuter.map((t) => t.label)}
//             active={activeOuterTab?.label ?? ""}
//             onChange={(label) => {
//               const tab = finalVisibleOuter.find((t) => t.label === label);
//               if (tab) setActiveOuter(tab.key);
//             }}
//           />
//         </div>
//       )}

//       {activeOuter === "ShipmentInventory" && visibleInner.length > 0 && (
//         <div className="space-y-4">
//           <div className="flex justify-between items-center">
//             <RoleToggle
//               options={visibleInner.map((t) => t.label)}
//               active={activeInnerTab?.label ?? ""}
//               onChange={(label) => {
//                 const tab = visibleInner.find((t) => t.label === label);
//                 if (tab) setActiveInner(tab.key);
//               }}
//             />
//           </div>

//           {activeInner === "Inventory" && <InventoryTab />}
//           {activeInner === "InventoryCheck" && <InventoryCheckTab />}
//         </div>
//       )}

//       {activeOuter === "ItemsInventory" && (
//         <div className="space-y-4">
//           <ItemInventory />
//         </div>
//       )}

//        {activeOuter === "ProductItemsMovement" && (
//         <div className="space-y-4">
//           <ProductItemsMovement />
//         </div>
//       )}

//       {activeOuter === "inventoryHeatMap" && (
//         <div className="space-y-4">
//           <LeadWMSDashboard />
//         </div>
//       )}
//     </div>
//   );
// };

// export default InventoryTabMain;

import React, { useEffect, useMemo, useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import InventoryCheckTab from "./_components/InventoryCheckTab";
import InventoryTab from "./_components/InventoryTab";
import ItemInventory from "./_components/ItemInventory";
import { useSelector } from "react-redux";
import { selectClientPermissions } from "../../features/auth/authSlice";
import ProductItemsMovement from "./_components/ProductMovement";
import LeadWMSDashboard from "./_components/WarehouseDashboard";
import {
  IconLayoutDashboard,
  IconBox,
  IconChecklist,
  IconArrowsExchange,
  IconPackage,
  IconGridDots,
} from "@tabler/icons-react";

interface TabConfig {
  key: string;
  label: string;
  component: React.ReactNode;
  modules: string[];
  operation: "read";
  icon?: React.ReactNode;
  description?: string;
}

const hasPermission = (
  permissions: ReturnType<typeof selectClientPermissions>,
  modules: string[],
  operation: "read",
) => {
  if (!permissions) return false;
  return modules.some((mod) =>
    permissions.some(
      (p) => p.module === mod && p.operations.includes(operation),
    ),
  );
};

interface InventoryTabMainProps {
  warehouseId?: string;
  activeOuter?: string;
  setActiveOuter?: (val: string) => void;
  activeInner?: string;
  setActiveInner?: (val: string) => void;
  searchQuery?: string;
}

const InventoryTabMain: React.FC<InventoryTabMainProps> = ({ 
  warehouseId,
  activeOuter: propActiveOuter,
  setActiveOuter: propSetActiveOuter,
  activeInner: propActiveInner,
  setActiveInner: propSetActiveInner,
  searchQuery
}) => {
  const permissions = useSelector(selectClientPermissions);
  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(null);

  const outerTabs: TabConfig[] = useMemo(
    () => [
      // {
      //   key: "inventoryHeatMap",
      //   label: "Dashboard",
      //   component: <LeadWMSDashboard />,
      //   modules: ["product_inventory"],
      //   operation: "read",
      //   icon: <IconLayoutDashboard size={18} />,
      //   description: "Warehouse overview & analytics"
      // },
      {
        key: "ShipmentInventory",
        label: "Shipment Inventory",
        component: null,
        modules: ["shipment_inventory"],
        operation: "read",
        icon: <IconPackage size={18} />,
        description: "Manage stock & shipments",
      },
      {
        key: "ItemsInventory",
        label: "Item Inventory",
        component: <ItemInventory warehouseId={warehouseId} />,
        modules: ["product_inventory"],
        operation: "read",
        icon: <IconBox size={18} />,
        description: "Product & item tracking",
      },
      {
        key: "InventoryCheck",
        label: "Inventory Check",
        component: <InventoryCheckTab searchQuery={searchQuery} />,
        modules: ["shipment_inventory"],
        operation: "read",
        icon: <IconChecklist size={18} />,
        description: "Audit & verify stock",
      },
      // {
      //   key: "ProductItemsMovement",
      //   label: "Movement",
      //   component: <ProductItemsMovement />,
      //   modules: ["product_inventory"],
      //   operation: "read",
      //   icon: <IconArrowsExchange size={18} />,
      //   description: "Stock movement history"
      // },
    ],
    [warehouseId, searchQuery],
  );

  const innerTabsForShipment: TabConfig[] = useMemo(
    () => [
      {
        key: "Inventory",
        label: "Inventory",
        component: <InventoryTab />,
        modules: ["shipment_inventory"],
        operation: "read",
        icon: <IconGridDots size={16} />,
        description: "Current inventory status",
      },
    ],
    [],
  );

  const visibleOuter = useMemo(
    () =>
      outerTabs.filter((t) => hasPermission(permissions, t.modules, "read")),
    [permissions, outerTabs],
  );

  const visibleInner = useMemo(
    () =>
      innerTabsForShipment.filter((t) =>
        hasPermission(permissions, t.modules, "read"),
      ),
    [permissions, innerTabsForShipment],
  );

  const shouldShowShipmentOuter =
    visibleOuter.some((t) => t.key === "ShipmentInventory") &&
    visibleInner.length > 0;

  const finalVisibleOuter = useMemo(() => {
    if (!shouldShowShipmentOuter) {
      return visibleOuter.filter((t) => t.key !== "ShipmentInventory");
    }
    return visibleOuter;
  }, [visibleOuter, shouldShowShipmentOuter]);

  const [localActiveOuter, setLocalActiveOuter] = useState<string>(() => {
    const saved = localStorage.getItem("InventoryWiseActiveRole");
    return saved && finalVisibleOuter.some((t) => t.key === saved)
      ? saved
      : (finalVisibleOuter[0]?.key ?? "");
  });

  const activeOuter = propActiveOuter !== undefined ? propActiveOuter : localActiveOuter;
  const setActiveOuter = propSetActiveOuter !== undefined ? propSetActiveOuter : setLocalActiveOuter;

  useEffect(() => {
    if (activeOuter)
      localStorage.setItem("InventoryWiseActiveRole", activeOuter);
  }, [activeOuter]);

  const [localActiveInner, setLocalActiveInner] = useState<string>(() => {
    const saved = localStorage.getItem("InventoryCheckActiveRole");
    return saved && visibleInner.some((t) => t.key === saved)
      ? saved
      : (visibleInner[0]?.key ?? "");
  });

  const activeInner = propActiveInner !== undefined ? propActiveInner : localActiveInner;
  const setActiveInner = propSetActiveInner !== undefined ? propSetActiveInner : setLocalActiveInner;

  useEffect(() => {
    if (activeInner)
      localStorage.setItem("InventoryCheckActiveRole", activeInner);
  }, [activeInner]);

  useEffect(() => {
    if (
      finalVisibleOuter.length &&
      !finalVisibleOuter.some((t) => t.key === activeOuter)
    ) {
      setActiveOuter(finalVisibleOuter[0].key);
    }
  }, [finalVisibleOuter, activeOuter]);

  useEffect(() => {
    if (
      activeOuter === "ShipmentInventory" &&
      visibleInner.length &&
      !visibleInner.some((t) => t.key === activeInner)
    ) {
      setActiveInner(visibleInner[0].key);
    }
  }, [visibleInner, activeInner, activeOuter]);

  const activeOuterTab = finalVisibleOuter.find((t) => t.key === activeOuter);
  const activeInnerTab = visibleInner.find((t) => t.key === activeInner);

  return (
    <div className="px-6 space-y-1 pb-8 animate-fadeIn">
      {/* Navigation matching Order section */}
      <header className="flex items-center justify-between w-full pb-2">
        {finalVisibleOuter.length > 1 ? (
          <RoleToggle
            options={finalVisibleOuter.map((t) => t.label)}
            active={activeOuterTab?.label ?? ""}
            onChange={(label) => {
              const tab = finalVisibleOuter.find((t) => t.label === label);
              if (tab) setActiveOuter(tab.key);
            }}
            activeClassName="bg-[#FBD037] text-[#131327] font-bold shadow-sm"
          />
        ) : (
          <div />
        )}
        <div ref={setPortalContainer} className="flex items-center gap-2.5" />
      </header>

      {/* Content Area */}
      <section className="min-h-[150px]">
        {activeOuter === "ShipmentInventory" && visibleInner.length > 0 && (
          <div className="space-y-1">
            {visibleInner.length > 1 && (
              <div className="flex items-center justify-between w-full pb-0">
                <RoleToggle
                  options={visibleInner.map((t) => t.label)}
                  active={activeInnerTab?.label ?? ""}
                  onChange={(label) => {
                    const tab = visibleInner.find((t) => t.label === label);
                    if (tab) setActiveInner(tab.key);
                  }}
                  activeClassName="bg-[#FBD037] text-[#131327] font-bold shadow-sm"
                />
              </div>
            )}

            <div className="animate-slideUp">
              {activeInner === "Inventory" && <InventoryTab warehouseId={warehouseId} searchQuery={searchQuery} portalContainer={portalContainer} />}
              {activeInner === "InventoryCheck" && <InventoryCheckTab searchQuery={searchQuery} portalContainer={portalContainer} />}
            </div>
          </div>
        )}

        {activeOuter === "ItemsInventory" && (
          <div className="animate-slideUp">
            <ItemInventory warehouseId={warehouseId} searchQuery={searchQuery} portalContainer={portalContainer} />
          </div>
        )}

        {activeOuter === "InventoryCheck" && (
          <div className="animate-slideUp">
            <InventoryCheckTab searchQuery={searchQuery} portalContainer={portalContainer} />
          </div>
        )}
      </section>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.4s ease-out;
        }
        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default InventoryTabMain;
